<template>
  <div>
    <span class="date_class">日期（Data）</span>
    <el-date-picker
      v-model="timeValue"
      :clearable="false"
      end-placeholder="结束时间（Hora de fim）"
      range-separator="-"
      start-placeholder="开始时间（Hora de início）"
      type="daterange"
      value-format="yyyy-MM-dd"
      style="width: 450px" size="small"
      :picker-options="pickerOptions"
      @change="dateChange"
    />
    <span style="display: inline-block; margin: 20px">
      <el-button type="primary" size="small" @click="search">查询（Consultar）</el-button>
      <el-button
        type="info" plain size="small"
        @click="reset"
      >重置（Resetar）</el-button>
      <el-button size="small" @click="exportAll">导出（Exportar）</el-button>
    </span>
    <el-table
      ref="tableRef"
      size="small" max-height="600" border
      style="width: 100%;margin-top: 20px"
      :header-cell-style="{background: '#e1e1e1', color: '#000', 'font-size': '15px'}"
      :data="tableData"
    >
      <el-table-column label="序号（No.）" width="80" align="center">
        <template slot-scope="scope">
          <span>{{ (queryForm.pageNumber - 1) * queryForm.pageSize + scope.$index + 1 }}</span>
        </template>
      </el-table-column>
      <el-table-column
        v-for="(item, index) in tableHeaderList"
        :key="index"
        align="center"
        :label="item.label"
        :prop="item.prop"
        :min-width="item.cloWidth"
        :show-overflow-tooltip="false"
        :class-name="getColumnClass(index)"
      >
        <template slot-scope="scope">
          <!--
            'firstUnloadMissCount' ? 3
            'firstArrivalMissCount' ? 5
            'firstBagMissCount' ? 7
            'firstLoadMissCount' ? 9
          -->
          <span
            v-if="
              item.prop === 'firstUnloadMissCount' ||
                item.prop === 'firstArrivalMissCount' ||
                item.prop === 'firstBagMissCount' ||
                item.prop === 'firstLoadMissCount'
            "
            style="color: #1990ff;cursor: pointer"
            @click="toDetail(scope.row, item.prop)"
          >{{ scope.row[item.prop] }}</span>
          <span v-else>{{ scope.row[item.prop] || scope.row[item.prop] === 0 ? scope.row[item.prop] : '--' }}</span>
        </template>
      </el-table-column>
    </el-table>
    <div class="right">
      <el-pagination
        layout="total, sizes, prev, pager, next, jumper"
        :current-page.sync="queryForm.pageNumber"
        :page-sizes="[10, 20, 50, 100, 500, 1000]"
        :page-size.sync="queryForm.pageSize"
        :total="total"
        background
        style="margin: 10px 0"
        @current-change="page"
        @size-change="search"
      />
    </div>
  </div>
</template>

<script>
import { sortingMissScanPage, sortingMissScanExport } from '@/api/orderApi';
import dayjs from 'dayjs';
import { goRWExportList } from '@/utils/goExportList.js';

export default {
  data() {
    return {
      timeValue: [],
      pickerOptions: {
        onPick: ({ maxDate, minDate }) => {
          this.selectDate = minDate.getTime();
          if (maxDate) {
            this.selectDate = '';
          }
        },
        disabledDate: (time) => {
          if (this.selectDate !== '') {
            const one = 30 * 24 * 3600 * 1000;
            const minTime = this.selectDate - one;
            const maxTime = this.selectDate + one;
            return time.getTime() < minTime || time.getTime() > maxTime;
          }
        }
      },
      tableData: [],
      total: 0,
      queryForm: {
        pageNumber: 1,
        pageSize: 10,
        params: {
          startDate: '',
          endDate: '',
          level: 1 // 分拣层级: 1 一级分拣, 2 二三级分拣
        }
      },
      tableHeaderList: [
        // 日期
        { label: '日期（Data）', prop: 'dataDate', cloWidth: '200' },
        // 一级解封车漏扫vtag数
        { label: '一级解封车漏扫vtag数（L1 Vtag Perd.Descarroç）', prop: 'firstUnsealMissVtagCount', cloWidth: '200' },
        // 一级应解封车vtag数
        { label: '一级应解封车vtag数（L1 Vtag a Descarroç）', prop: 'firstShouldUnsealVtagCount', cloWidth: '170' },
        // 一级解封车漏扫率
        { label: '一级解封车漏扫率（L1 % Perd.Descarroç）', prop: 'firstUnsealMissRate', cloWidth: '170' },
        // 一级卸车漏扫数
        { label: '一级卸车漏扫数（L1 Perd.Descarga）', prop: 'firstUnloadMissCount', cloWidth: '150' },
        // 一级到件票数
        { label: '一级到件票数（L1 Tickets Chegada）', prop: 'firstArrivalCount', cloWidth: '130' },
        // 一级卸车漏扫率
        { label: '一级卸车漏扫率（L1 % Perd.Descarga）', prop: 'firstUnloadMissRate', cloWidth: '150' },
        // 一级到件漏扫数
        { label: '一级到件漏扫数（L1 Perd.Chegada）', prop: 'firstArrivalMissCount', cloWidth: '150' },
        // 一级发件数
        { label: '一级发件数（L1 Cont. Remessa）', prop: 'firstShipmentCount', cloWidth: '128' },
        // 一级到件漏扫率
        { label: '一级到件漏扫率（L1 % Perd.Chegada）', prop: 'firstArrivalMissRate', cloWidth: '150' },
        // 一级集包漏扫数
        { label: '一级集包漏扫数（L1 Perd.Consol.）', prop: 'firstBagMissCount', cloWidth: '150' },
        // 一级装车数
        { label: '一级装车数（L1 Cont.Carreg.）', prop: 'firstLoadCount', cloWidth: '128' },
        // 一级集包漏扫率
        { label: '一级集包漏扫率（L1 % Perd.Consol.）', prop: 'firstBagMissRate', cloWidth: '150' },
        // 一级装车漏扫数
        { label: '一级装车漏扫数（L1 Perd.Carreg.）', prop: 'firstLoadMissCount', cloWidth: '150' },
        // 二级或网点入库票数
        { label: '二级或网点入库票数（Tickets Entrada L2）', prop: 'secondOrSiteArrivalCount', cloWidth: '170' },
        // 一级装车漏扫率
        { label: '一级装车漏扫率（L1 % Perd.Carreg.）', prop: 'firstLoadMissRate', cloWidth: '150' },
        // 一级封车漏扫vtag数
        { label: '一级封车漏扫vtag数（L1 Vtag Perd.Encarroç）', prop: 'firstSealMissVtagCount', cloWidth: '170' },
        // 一级应封车vtag数
        { label: '一级应封车vtag数（L1 Vtag a Encarroç）', prop: 'firstShouldSealVtagCount', cloWidth: '150' },
        // 一级封车漏扫率
        { label: '一级封车漏扫率（L1 % Perd.Encarroç）', prop: 'firstSealMissRate', cloWidth: '150' }
      ]
    };
  },
  created() {
    this.toSearch();
  },
  methods: {
    reset() {
      this.defaultTime();
      this.queryForm.pageNumber = 1;
      this.queryForm.pageSize = 10;
      this.search();
    },
    toSearch() {
      this.defaultTime();
      this.search();
    },
    getColumnClass(index) {
      if (index >= 1) {
        const groupIndex = Math.floor((index - 1) / 3);
        return groupIndex % 2 === 0 ? 'yellow-column' : 'blue-column';
      }
      return '';
    },
    defaultTime() {
      // 前一天
      const yesterday = dayjs().subtract(1, 'day').format('YYYY-MM-DD');
      this.timeValue = [yesterday, yesterday];
      this.queryForm.params.startDate = yesterday;
      this.queryForm.params.endDate = yesterday;
    },
    dateChange(val) {
      if (val === null) {
        this.timeValue = [];
        return;
      }
      this.queryForm.params.startDate = val[0];
      this.queryForm.params.endDate = val[1];
      // 可以直接处理搜索逻辑
      this.search();
    },
    search() {
      this.queryForm.pageNumber = 1;
      this.page();
    },
    page() {
      const queryForm = JSON.parse(JSON.stringify(this.queryForm));
      queryForm.params.level = 1;
      sortingMissScanPage(queryForm).then(res => {
        if (res.code === 200) {
          this.tableData = res.data.records;
          this.total = res.data.total;
        }
      });
    },
    exportAll() {
      if (this.tableData.length <= 0) {
        this.$message.warning('列表暂无数据，无法导出（A lista não tem dados e não pode ser exportada）');
      } else {
        sortingMissScanExport(this.queryForm.params).then(res => {
          if (res.code === 200) {
            goRWExportList(this);
          }
        });
      }
    },

    // 打开明细
    toDetail(row, type) {
      // dataType  数据类型: 3 一级卸车漏扫数, 5 一级到件漏扫数, 7 一级集包漏扫数, 9 一级装车漏扫数
      const typeVal = type === 'firstUnloadMissCount' ? 3 : type === 'firstArrivalMissCount' ? 5 : type === 'firstBagMissCount' ? 7 : type === 'firstLoadMissCount' ? 9 : null;
      let dataDate = [];
      if (row.dataDate.includes('~')) {
        dataDate = row.dataDate.split('~');
      } else {
        dataDate = [row.dataDate, row.dataDate];
      }
      this.$emit('parentMethod', dataDate[0], dataDate[1], typeVal, [], []);
    }
  }
};
</script>

<style lang="scss" scoped>
.right{
  display: flex;
  justify-content: flex-end;
  align-items: center;
}
.date_class {
  display: inline-block;
  font-size: 14px;
  color: #606266;
  font-weight: 700;
  margin-right: 10px;
}
::v-deep .el-table th.blue-column {
  background-color: #e5f6fd !important;
}
::v-deep .el-table th.yellow-column {
  background-color: #fbe1be !important;
}
</style>
